module.exports = __webpack_public_path__ + "img/banner_2.e1616b27.jpg";